import { ANNOTATION_FIELD_TYPE } from '@/constants/annotation';
import { AnnotationTemplateField, AnnotationTemplateSelectField } from '@/graphql/codegen/graphql';
import { WithMode } from '@/stores/template';
import { OptionEdit } from './OptionEdit';

export const FieldValue = ({ field }: { field: WithMode<AnnotationTemplateField> }) => {
  if (field.type !== ANNOTATION_FIELD_TYPE.SELECT) return null;

  return <OptionEdit field={field as WithMode<AnnotationTemplateSelectField>} />;
};
